import { getFileIcon } from 'shared/utils/file/fileIcon'
import { cn } from 'shared/utils/cn'

type FileIconProps = {
  type: string
  className?: string
}

const FileIcon = ({ type, className }: FileIconProps) => (
  <div
    className={cn(
      'h-[20px] w-[20px] [&>svg]:!fill-surface-common-icon-color',
      className
    )}
  >
    {getFileIcon(type, { size: 'medium' })}
  </div>
)

export default FileIcon
